import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-offcanvas',
  templateUrl: './offcanvas.component.html',
  styleUrls: ['./offcanvas.component.scss'],
})
export class OffcanvasComponent implements OnInit {
  @Input() showSubject = new Subject<boolean>();
  @Input() show: boolean = false;
  @Input() size: 'medium';
  @Input() styleClass: string;
  @Input() title: string;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() footerTemplate: TemplateRef<any>;
  @Output() dismissed = new EventEmitter<void>();

  constructor(public _location: Location) {}

  ngOnInit(): void {
    if (this.showSubject)
      this.showSubject.subscribe((show) => {
        this.show = show;
      });
  }

  goBack() {
    this._location.back();
  }

  dismiss(): void {
    this.hideOffCanvas();
    this.dismissed.emit();
  }

  hideOffCanvas(): void {
    this.show = false;
  }
  showOffCanvas() {
    this.show = true;
  }
}
